import ctx from '../../plugins/axios';

const updateListParticipants = async ({ uuid, reviewerlist, approverlist, updated_by }) => {
  return await ctx.put(
    `/specialty-list-participants?uuid=${encodeURIComponent(uuid)}`,
    { reviewerlist, approverlist, updated_by }
  );
};

export default updateListParticipants;
